export default "Beach your opponents! The last boat floating wins.";